import React from 'react';
import dayjs from 'dayjs';
import { ResourceRequestItem } from '../../../hooks/incidentResourceRequestHooks';

interface RequestItemsProps {
  items: ResourceRequestItem[];
  totalItemCount: number;
}

const RequestItems: React.FC<RequestItemsProps> = ({
  items,
  totalItemCount,
}) => (
  <div className="mt-2">
    <strong>Requested Items:</strong>
    {items.map((item: ResourceRequestItem, idx: number) => (
      <div key={idx} className="ms-2">
        • {item.quantity || 0} {item.unit || 'Each'} - {item.kind || 'Unknown'}
        {item.requested_reporting_datetime && (
          <div className="text-muted small ms-3">
            Need by:{' '}
            {dayjs(item.requested_reporting_datetime).format(
              'MM/DD/YYYY HH:mm'
            )}
          </div>
        )}
      </div>
    ))}
    {/* Show ... if there are more items than displayed */}
    {totalItemCount > items.length && (
      <div className="ms-2 text-muted">...</div>
    )}
  </div>
);

export default RequestItems;
